import { render, staticRenderFns } from "./loginV2.vue?vue&type=template&id=7bc77503&scoped=true&"
import script from "./loginV2.vue?vue&type=script&lang=js&"
export * from "./loginV2.vue?vue&type=script&lang=js&"
import style0 from "./loginV2.vue?vue&type=style&index=0&id=7bc77503&lang=scss&scoped=true&"
import style1 from "./loginV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc77503",
  null
  
)

export default component.exports